/* eslint-disable no-console,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal, CalendarHeaderV1, CalendarWrapper, ConfirmVisitTextV1, ButtonContainerV3, ButtonV3
} from '../PeopleHomeV2/ManageBuddies/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { deleteSocialInspiration, sendFriendRequest, getSuggestionsList, removeBuddy, acceptOrRejectFriendRequest} from '../../redux/actions';
import { HeadingV1 } from './styles';
import { Divider, ManagerIconContainer } from '../Manager/styles';
import { AdminCloseIcon, AdminDeleteIcon, RecognitionWarningIcon } from '../../utils/icons';
import { FeedIconContainer } from '../SocialFeedsV2/styles';
import { StyledTitleV3 } from '../SocialFeeds/styles';
import { withRouter } from 'react-router-dom/cjs/react-router-dom'

class DeletePostPopup extends Component {
  constructor(props) {
    super(props);
  }

  deletePost = () => {
    const { deleteSocialInspiration, feed, onClose, updationList, isFlaggedPost,history} = this.props;
    if (history.location.pathname.includes('manager')) {
      deleteSocialInspiration(feed.id, updationList,10, isFlaggedPost,'Manager');

    }else{
      deleteSocialInspiration(feed.id, updationList,10, isFlaggedPost);

    }
    
    onClose();
  };

  addBuddy = (Id) => {
    const { sendFriendRequest, onClose, socialCallBack, getSuggestionsList} = this.props;
    sendFriendRequest(Id, false);
    getSuggestionsList();
    socialCallBack();
    onClose();
  }

  rejectBuddy = (Id) => {
    const { onClose, socialCallBack, removeBuddy, getSuggestionsList, feedID} = this.props;
    removeBuddy(Id, feedID);
    getSuggestionsList();
    socialCallBack();
    onClose();
  }

  acceptOrRejectRequest = (id, status) => {
    const { acceptOrRejectFriendRequest, onClose, socialCallBack } = this.props;
    onClose();
    acceptOrRejectFriendRequest({ request_id: id, status: status });
    socialCallBack();
  };

  render() {
    const { showModal, onClose, showpending, showAddBuddy, buddyDetails, showConfirm, requestId, deletePopupOrganization, deleteOrganization, string } = this.props;
    const userId= buddyDetails && buddyDetails?.length && buddyDetails[0] && buddyDetails[0].uid;
    return (
      <StyledModal show={showModal ? true : false} width={"400px"}>
        {showpending||showAddBuddy||showConfirm?<CalendarHeaderV1  isFontType={"Lato"} color={"#184A61"} isContent={"flex-start"} style={{background:"#FEFEFE"}}>
          {/* <ManagerIconContainer style={{marginRight:"4px"}}>{RecognitionWarningIcon("#DA6C74")}</ManagerIconContainer>  */}
          <div className="popUpHeader">{showpending ? "Cancel Connection Request" : showAddBuddy ?  ("Send Connection Request"):  ("Confirm Connection Request") }</div>
          <FeedIconContainer className="close-icon"  onClick={showConfirm?() => this.acceptOrRejectRequest(requestId, 'Rejected'): () => onClose()}>
            {AdminCloseIcon()}
          </FeedIconContainer>
        </CalendarHeaderV1>:
          <HeadingV1 isColor="#184A61" >
            <ManagerIconContainer className="icon">{RecognitionWarningIcon("#DA6C74")}</ManagerIconContainer> 
            <StyledTitleV3> {deletePopupOrganization?`Delete ${string}`:"Delete Post"}</StyledTitleV3>
            <FeedIconContainer className="close-icon" onClick={ () => onClose()}>
              {AdminCloseIcon()}
            </FeedIconContainer>
          </HeadingV1>}
        <Divider isWidth="90%" isMargin={"4px 16px 0px 16px"}></Divider> 

        <CalendarWrapper padding="0 16px 16px 16px">
          {deletePopupOrganization?
            <ConfirmVisitTextV1>{this.props.t("Are you sure you want to delete")} <br/>{this.props.t("this ")} {string}?</ConfirmVisitTextV1>
            :
            showpending?
              <ConfirmVisitTextV1>
                {("Are you sure you want to cancel this connection request? The recipient will no longer see your pending request.")}
              </ConfirmVisitTextV1>:
              showAddBuddy?
                <ConfirmVisitTextV1>
                  {("Are you sure you want to send a connection request? This will notify the recipient that you’d like to connect.")}
                </ConfirmVisitTextV1>:
                showConfirm?<ConfirmVisitTextV1>
                  {this.props.t("Are you sure to want to accept")} <br/>{this.props.t("the Buddy Request?")}
                </ConfirmVisitTextV1>:
                  <div>
                    <ConfirmVisitTextV1>
                     Are you sure you want to delete this post?
                    </ConfirmVisitTextV1>
                    <ConfirmVisitTextV1 textColor={"#CE7841"} isMargin={"16px 0px 20px 0px"}>
                    This action cannot be undone, and the post will be permanently removed from the system.
                    </ConfirmVisitTextV1>
                  </div>
          }  
          {(showConfirm || showpending || showAddBuddy || deletePopupOrganization ) ? (<ButtonContainerV3>
            <ButtonV3
              background="transparent"
              color="#184A61"
              onClick={showConfirm ? () => this.acceptOrRejectRequest(requestId, 'Rejected'): () => onClose()}
              width="80px"
              // backgroundHover="#007AB1"
              colorHover="#184A61"
            >
              {this.props.t("Cancel")}
            </ButtonV3>
            <ButtonV3
              background="#F37A65"
              onClick={deletePopupOrganization?()=>deleteOrganization(): showConfirm?() => this.acceptOrRejectRequest(requestId,'Accepted'): showAddBuddy?() => this.addBuddy(userId):showpending?  () => this.rejectBuddy(userId):  null}
              width="110px"
              backgroundHover="#EA6149"
              colorHover="white"
              color="white"
            >
              {this.props.t("Confirm")}
            </ButtonV3>
           
          </ButtonContainerV3>) :
            <ButtonContainerV3>
              <ButtonV3
                background="transparent"
                color="#184A61"
                onClick={ () => onClose()}
                width="103px"
                // backgroundHover="#007AB1"
                colorHover="#184A61"
              >
                {this.props.t("Keep Post")}
              </ButtonV3>
              <ButtonV3
                background="#F37A65"
                onClick={() => this.deletePost()}
                width="200px"
                backgroundHover="#EA6149"
                colorHover="white"
                color="white"
              >
                <div style={{marginRight:"8px",display:"flex"}}> {AdminDeleteIcon("white")} </div>
                {this.props.t("Delete Permanently")}
              </ButtonV3>
             
            </ButtonContainerV3>}

        </CalendarWrapper>
      </StyledModal>
    );
  }
}

DeletePostPopup.propTypes = {
  showModal: PropTypes.string,
  onClose: PropTypes.func,
  deleteSocialInspiration: PropTypes.func,
  feed: PropTypes.any,
  updationList: PropTypes.string,
  deleteUser: PropTypes.func,
  t: PropTypes.func,
  sendFriendRequest: PropTypes.func,
  getSuggestionsList: PropTypes.func,
  socialCallBack: PropTypes.func,
  removeBuddy: PropTypes.func,
  showpending: PropTypes.bool,
  showAddBuddy: PropTypes.bool,
  buddyDetails: PropTypes.array,
  showConfirm: PropTypes.bool,
  acceptOrRejectFriendRequest: PropTypes.func,
  requestId: PropTypes.bool,
  deletePopupOrganization: PropTypes.string,
  deleteOrganization: PropTypes.func,
  string: PropTypes.string,
  feedID: PropTypes.number,
  isFlaggedPost:PropTypes.bool,
  history:PropTypes.object
};

const mapStateToProps = (state) => ({
  sendRequest: state.social.sendRequest,
  friendRequests: state.social.friendRequests,
});

const mapDispatchToProps = (dispatch) => ({
  deleteSocialInspiration: (id, updationList,limit, isFlaggedPost,filterType) => dispatch(deleteSocialInspiration(id, updationList,limit,isFlaggedPost,filterType)),
  sendFriendRequest: (data, bool) => dispatch(sendFriendRequest(data, bool)),
  getSuggestionsList: () => dispatch(getSuggestionsList()),
  removeBuddy: (acceptData, feedID) => dispatch(removeBuddy(acceptData, feedID)),
  acceptOrRejectFriendRequest: (acceptData) => dispatch(acceptOrRejectFriendRequest(acceptData))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(DeletePostPopup)));